import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { ReportActions, ReportDescription, ReportSection, ReportToggle, ReportToggleList } from '../ReportFormUi';
import '../../SchoolEventView.scss';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

//report 009
export function EventAvailabilityReportsReportForm({ onCloseClick, onSubmit }: Props) {
  const requestInitial = {
    isShowAll: false
  };

  return (
    <Formik
      onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.EVENT_AVAILABILITY_REPORTS)}
      initialValues={requestInitial}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>
            See availability reports sent for this event or activity. You can include every response or only the most
            recent response for each student.
          </ReportDescription>

          <ReportSection
            number={1}
            title="Responses"
            hint="Choose how duplicate availability responses should be handled."
          >
            <ReportToggleList>
              <ReportToggle
                name="isShowAll"
                label="Show all responses"
                hint="Otherwise the report shows one availability report per student, using the most recent response."
                value={values.isShowAll}
                onChange={value => setFieldValue('isShowAll', value)}
              />
            </ReportToggleList>
          </ReportSection>

          <ReportActions onCancel={onCloseClick} />
        </Form>
      )}
    </Formik>
  );
}
